export default "__VITE_ASSET__CvOHsKTa__"